import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'corner-right-up', 'IconCornerRightUp', [["path",{"d":"M6 18h6a3 3 0 0 0 3 -3v-10l-4 4m8 0l-4 -4","key":"svg-0"}]]);